import React, { forwardRef } from "react";
import { useSpring, animated as A } from "react-spring";
import { Error as ErrorText, Label } from "../Input/styles";
import * as S from "./styles";
export var Dropdown = forwardRef(function (e, t) {
  var a = e.className,
      r = e.error,
      l = e.hideLabel,
      o = e.id,
      n = e.items,
      c = e.label,
      s = e.name,
      d = e.onChange,
      i = e.onClick,
      m = e.onFocus,
      p = e.onBlur,
      u = e.placeholderText,
      E = e.value,
      R = e.disabled,
      _e$showErrorMessage = e.showErrorMessage,
      b = _e$showErrorMessage === void 0 ? !1 : _e$showErrorMessage,
      f = e.helperText,
      h = "".concat(o, "-error"),
      x = useSpring({
    opacity: r ? 1 : 0
  });
  return React.createElement(S.Wrapper, {
    hideLabel: l,
    className: a,
    error: r
  }, React.createElement(Label, {
    htmlFor: s
  }, c), React.createElement(S.SelectWrapper, null, React.createElement(S.Select, {
    onChange: function onChange(e) {
      d && d(e);
    },
    onClick: function onClick(e) {
      i && i(e);
    },
    onFocus: function onFocus(e) {
      m && m(e);
    },
    onBlur: function onBlur(e) {
      p && p(e);
    },
    name: s,
    id: s,
    "data-testid": s,
    ref: t,
    value: E && E,
    disabled: R
  }, u ? React.createElement(S.Option, {
    value: "",
    disabled: !0,
    selected: !0,
    hidden: !0
  }, u) : null, n.map(function (e) {
    return React.createElement(S.Option, {
      key: e.id,
      value: e.value,
      disabled: !!e.isDisabled
    }, e.text || e.value);
  })), React.createElement(S.DownArrow, {
    disabled: R
  })), (b && r ? React.createElement(ErrorText, {
    id: h,
    "data-testid": h
  }, React.createElement(A.span, {
    style: x
  }, r)) : null) || (f ? React.createElement(S.HelperText, null, f) : null));
});
export default Dropdown;